// required to avoid `setImmediate is not defined` in React Native Web
import * as React from 'react';
import { View } from 'react-native';
import RootSiblings from 'react-native-root-siblings';
import 'setimmediate';

import KitSnackItem from './KitSnackItem';

//******************************************************************************
// Types
//******************************************************************************
interface IProps {
  animationsEnabled?: boolean;
  autoHide?: boolean;
  duration: number;
  marginBottom?: number;
  message: string;
  onHide?: () => void;
  root?: RootSiblings;
}

const duration = {
  LONG: 3500,
  SHORT: 2000,
  SUPER_LONG: 10000,
};

//******************************************************************************
// Components
//******************************************************************************

export default class KitSnack extends React.Component<IProps, any> {
  //****************************************************************************
  // Static Properties
  //****************************************************************************
  static _snack: null | RootSiblings = null;
  static duration = duration;

  static show = (
    message = '',
    duration = KitSnack.duration.SHORT
  ): RootSiblings => {
    const snack = new RootSiblings(<View />); // This is a hack to get a reference to our root container, in a static context, in order to destroy ourself after animation
    snack.update(
      <KitSnackItem message={message} duration={duration} root={snack} />
    );

    return snack;
  };

  static hide = (snack: RootSiblings): void => {
    if (snack instanceof RootSiblings) {
      snack.destroy();
    } else {
      console.warn(
        `KitSnack.hide expected a \`RootSiblings\` instance.\nBut got \`${typeof snack}\` instead.`
      );
    }
  };
}
